import {
  useModalOldContext,
  WSButton,
  WSElement,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { UPDATE_COLLABORATOR_GROUP_MODAL } from "../../components/UpdateCollaboratorGroupModal";
import { useCollaboratorGroupQuery } from "../../../../query/payments/queries";
import { DetailsLayout } from "../../../../components/DetailsLayout/DetailsLayout";
import { WSQueries } from "../../../../query/WSQuery";
import { PAYEES_GROUPS_LIST_PATH } from "../../utils";

export const CollaboratorGroupDetails: React.FC<
  RouteComponentProps<{
    collaboratorGroupId: string;
  }>
> = ({
  match: {
    params: { collaboratorGroupId }
  }
}) => {
  const history = useHistory();
  const collaboratorGroupQuery = useCollaboratorGroupQuery(collaboratorGroupId);

  const { openModal } = useModalOldContext();

  return (
    <DetailsLayout
      onBack={() => {
        history.push(PAYEES_GROUPS_LIST_PATH);
      }}
      title={collaboratorGroupQuery.data?.name || ""}
    >
      <WSQueries queries={{ collaboratorGroupQuery }}>
        {({ collaboratorGroupQuery: { data: collaboratorGroup } }) => (
          <>
            <DetailsLayout.Card mb="XL">
              <WSFlexBox wrap="nowrap" justify="space-between">
                <WSElement>
                  <WSText weight="medium" mb="M">
                    {collaboratorGroup.name}
                  </WSText>
                  <WSText>{collaboratorGroup.description}</WSText>
                </WSElement>
                <WSButton.Link
                  onClick={() => {
                    openModal(UPDATE_COLLABORATOR_GROUP_MODAL, {
                      id: collaboratorGroupId,
                      name: collaboratorGroup.name,
                      description: collaboratorGroup.description
                    });
                  }}
                >
                  Edit
                </WSButton.Link>
              </WSFlexBox>
            </DetailsLayout.Card>
          </>
        )}
      </WSQueries>
    </DetailsLayout>
  );
};
